import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

export const EVENT_INFO = {
  title: '웰로 로컬페스타 2025',
  date: '2025. 11. 30. SUN.',
  time: '13:00 ~ 19:00',
  location: '서울 여의도 콘래드 호텔 3F 그랜드볼룸',
  targetDate: new Date('2025-11-30T13:00:00'),
};

export const EVENT_DETAILS = [
  { label: '일시', value: '2025. 11. 30. (일) 13:00 ~ 19:00' },
  { label: '장소', value: '서울 여의도 콘래드 호텔 3F 그랜드볼룸' },
  { label: '모집대상', value: '웰로, 고향사랑기부제에 관심있는 누구나' },
  { label: '모집인원', value: '선착순 1,000명' },
  { label: '주최', value: '주식회사 웰로' },
  {
    label: '참여지역',
    value:
      '강원 강릉, 경북 영주, 경남 통영\n광주 남구, 광주 서구, 전남 도청\n전남 영암, 전북 임실, 제주 도청\n충남 논산',
  },
];

export const ONLINE_EVENTS = [
  {
    id: 1,
    badge: '1명',
    image: `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/price1.png`,
  },
  {
    id: 2,
    badge: '1명',
    image: `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/price2.png`,
  },
  {
    id: 3,
    badge: '1명',
    image: `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/price3.png`,
  },
  {
    id: 5,
    badge: '100명',
    image: `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/price5.png`,
  },
];

export const FAQ_DATA = [
  {
    id: 'faq-category-signup',
    title: '참가신청에 대하여',
    items: [
      {
        id: 'faq-signup-001',
        question: '참가 신청은 어떻게 하나요?',
        answer:
          '참가 신청은 2025년 11월 5일부터 웰로 로컬페스타 2025 웹사이트에서 할 수 있습니다.',
      },
      {
        id: 'faq-signup-002',
        question: '참가자는 어떻게 선정하나요?',
        answer:
          '참가자는 참가신청 선착순으로 자동 선정됩니다. 참가신청 후 결과 페이지에서 확인 가능합니다.',
      },
      {
        id: 'faq-signup-003',
        question: '참가 신청은 유료인가요?',
        answer: '참가 신청 및 참석은 무료입니다.',
      },
      {
        id: 'faq-signup-004',
        question: '신청 시 자격 제한이 있나요?',
        answer:
          '웰로 로그인 후 관심 있는 분이라면 누구든지 신청할 수 있습니다.',
      },
      {
        id: 'faq-signup-005',
        question: '현장에서도 참가 신청을 할 수 있나요?',
        answer: '현장에서는 별도로 신청받지 않습니다.',
      },
      {
        id: 'faq-signup-006',
        question: '입장을 양도할 수 있나요?',
        answer: '양도가 불가하며 신청하신 본인만 행사에 참석할 수 있습니다.',
      },
      {
        id: 'faq-signup-007',
        question: '참가 신청 기간이 지나고 신청할 방법이 있나요?',
        answer:
          '신청 기간 이후 추가 모집은 하지 않습니다. 최대한 많은 분들을 모시고 싶으나, 공간이 한정되어 어려운 점 양해 부탁드립니다.',
      },
      {
        id: 'faq-signup-008',
        question: '굿즈는 어떻게 받을 수 있나요?',
        answer:
          '웰컴 굿즈는 참가자에게 드리며 미션 굿즈는 행사장 내 웰로 이벤트를 통해 선착순으로 받으실 수 있습니다.',
      },
      {
        id: 'faq-signup-009',
        question: '참가 신청 선물은 어떻게 받을 수 있나요?',
        answer:
          '참가 신청 후 행사장에 직접 방문하신 분들 중 추첨을 통해 드립니다. 당첨자는 행사가 종료된 후 웰로 공지사항을 통해 발표될 예정입니다.',
      },
    ],
  },
  {
    id: 'faq-category-event',
    title: '행사에 대하여',
    items: [
      {
        id: 'faq-event-001',
        question: '당일 어떻게 입장하나요?',
        answer:
          '참가 신청 후 마지막 페이지에 보여지는 입장권을 안내 데스크에 제시해 주시면 입장을 도와드립니다. 입장권은 신청 조회를 통해서도 확인 가능합니다.',
      },
      {
        id: 'faq-event-002',
        question: '입장 시간 제한이 있나요?',
        answer:
          '운영시간 내 원하는 시간에 참석 가능하며, 먼저 안내 데스크에 방문해 주시면 됩니다.',
      },
      {
        id: 'faq-event-003',
        question: '주차권이 제공되나요?',
        answer:
          '주차권은 지원하지 않습니다. 주차 공간이 부족하고 혼잡하오니 대중교통을 이용해 주시길 바랍니다.',
      },
      {
        id: 'faq-event-004',
        question: '점심식사를 제공하나요?',
        answer: '점심 식사는 제공하지 않습니다.',
      },
      {
        id: 'faq-event-005',
        question: '행사장 내 취식이 가능하나요?',
        answer: '위생 문제가 발생할 수 있어 행사장 내 취식은 어렵습니다.',
      },
      {
        id: 'faq-event-006',
        question: 'Wi-Fi 사용과 충전기를 대여할 수 있나요?',
        answer: 'Wi-Fi는 제공되며, 충전기는 별도로 제공하지 않습니다.',
      },
      {
        id: 'faq-event-007',
        question: '행사장에 도착하면 어디로 이동해야 하나요?',
        answer:
          '콘래드 호텔 1층에 도착하시면 유리 엘리베이터를 이용해 3층에 내리시면 그랜드볼룸 앞 안내 데스크가 위치해 있습니다. 입장권 확인 후 행사장 입장 도와드립니다.',
      },
    ],
  },
];

export const MAP_INFO = {
  address: '서울 영등포구 국제금융로 10 서울 국제금융 센터',
  transport: '5호선, 9호선 여의도역 3번 출구에서 550m',
};

export const PROGRAM_INTRO = {
  slogan: {
    main: '고향을 담다',
    sub: '로컬을 잇다',
  },
  descriptions: [
    '지역 균형발전을 돕는 거브테크(Gov-Tech) 기업 웰로가 열 곳의 지역과 함께 "웰로 로컬페스타"를 처음 개최합니다.',
    '정책은 손으로 직접 느끼고, 마음으로 공감할 때 비로소 반응합니다.',
    '고향의 가치와 로컬의 가능성을 오프라인에서 직접 경험하고 연결되는 시간 "웰로 로컬페스타 2025"에서 만나보세요.',
    '지속가능한 지역의 미래, 웰로가 함께 만들어갑니다.',
  ],
};

export const WELLPOINT_INFO = {
  title: '웰포인트가 뭔가요?',
  description:
    '웰로에서 드리는 현금성 포인트에요.\n네이버페이, 카카오페이, 배달의민족 등\n다양한 쿠폰으로 교환이 가능합니다.',
  logos: [
    `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/naver-pay.png`,
    `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/kakao-pay.png`,
    `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/woowa.png`,
  ],
};
